<template>
    <div>
        <div v-if="attribute_definition">
            <div v-if="attribute_definition.display">
                <div v-if="attribute_definition.value_type==='list'">
                    <p>{{attribute_definition.label}}</p>
                    <el-select filterable v-model="selected_value" @change="handleChange">
                        <el-option
                                v-for="(value,key) in attribute_definition.values"
                                :key = "key"
                                :label = "value"
                                :value = "parseInt(key, 10)">
                        </el-option>
                    </el-select>
                </div>
                <div v-if="attribute_definition.value_type==='boolean'">
                    <el-checkbox v-model="selected_value_boolean" @change="handleBooleanChange">{{attribute_definition.label}}</el-checkbox>
                </div>
                <div v-if="attribute_definition.value_type==='integer'">
                    <p>{{attribute_definition.label}}</p>
                    <el-input @change="handleIntegerChange" v-model="selected_value"></el-input>
                </div>
                <div v-if="attribute_definition.instructions"><em>{{attribute_definition.instructions}}</em></div>
            </div>
        </div>
        <div v-else>
            <p>{{field_name}}</p>
            <el-input @change="handleChange" v-model="selected_value"></el-input>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['initial_value', 'attribute_definition', 'field_name'],
        watch: {
            initial_value: function (val) {
                this.selected_value = val
                this.selected_value_boolean = Boolean(val)
            },
        },
        mounted() {
            this.selected_value = this.initial_value
            this.selected_value_boolean = Boolean(this.initial_value)
        },
        data() {
            return {
                selected_value: null,
                selected_value_boolean: false
            }
        },
        methods: {
            handleChange(value) {
                let field_name = this.field_name
                this.$emit('change',{value,field_name})
            },
            handleBooleanChange(boolean_value) {
                let field_name = this.field_name
                console.log('boolean_value')
                console.log(boolean_value)
                let value = boolean_value ? 1 : 0
                console.log('value')
                console.log(value)
                this.$emit('change',{value, field_name})
            },
            /*
            handleIntegerChange(string_value) {
                  let field_name = this.field_name
                  let value = parseInt(string_value,10)
                this.$emit('change',{value,field_name})
            },
             */
            buildSelectObject(value) {
                return {value, label:this.attribute_definition.values[value]}
            }
        }
    }
</script>